import { render, staticRenderFns } from "./PesquisaInteligente.vue?vue&type=template&id=95ea7b52&scoped=true&lang=pug"
import script from "./PesquisaInteligente.vue?vue&type=script&lang=js"
export * from "./PesquisaInteligente.vue?vue&type=script&lang=js"
import style0 from "./PesquisaInteligente.vue?vue&type=style&index=0&id=95ea7b52&prod&lang=scss&scoped=true"
import style1 from "./PesquisaInteligente.vue?vue&type=style&index=1&id=95ea7b52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ea7b52",
  null
  
)

export default component.exports